import { PageData } from 'actions/pageActions'

/** Server-only: derive initial DTI tool payload (e.g. CMS, cookies). Currently none. */
export function buildInitialDtiData(pageProps: PageData): unknown | undefined {
  void pageProps
  return undefined
}
